interface SelectProps {
    value: string;
    onChange: (value: string) => void;
    options: string[];
}

export const Select = ({ value, onChange, options }: SelectProps) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
            {
                options.map((option) => (
                    <option key={option} value={option}>{option}</option>
                ))
            }
        </select>
    );
};